<template>
  <v-dialog v-model="dialog" persistent="persistent" max-width="1000px">
    <v-card grid-list-md="grid-list-md">
      <v-card-title>
        <h1 class="title">{{ $t("pageHeader.newLead") }}</h1>
        <v-spacer> </v-spacer>
        <v-btn icon flat fab small @click="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pt-0">
        <v-container grid-list-lg>
          <v-layout row wrap>
            <v-flex xs12>
              <v-layout row wrap>
                <v-flex xs12 sm4>
                  <v-autocomplete
                    v-model="Lead.reporterUserID"
                    :items="users"
                    :error-messages="reporterUserErrors"
                    item-text="fullName"
                    item-value="userID"
                    :label="$t('labels.leadFounder')"
                  >
                  </v-autocomplete>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-autocomplete
                    :items="comboBoxByID(3).ComboBoxDetails"
                    :label="$t('labels.product')"
                    item-text="selector"
                    :error-messages="softwareErrors"
                    item-value="id"
                    v-model="Lead.softwareID"
                  >
                  </v-autocomplete>
                </v-flex>
                <v-flex xs12 sm4>
                  <DateTimePicker
                    :showIcon="false"
                    :range="false"
                    :clearable="false"
                    :hideTime="false"
                    label="Next follow up date"
                    v-on:input="setFollowingDate"
                    :initStartDate="$moment(Lead.dueDate)"
                    :noFuture="true"
                  >
                  </DateTimePicker>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12>
              <v-divider> </v-divider>
            </v-flex>
            <v-flex xs12>
              <div>Lead Detail</div>
              <v-layout row wrap>
                <v-flex xs12 sm3>
                  <v-text-field
                    :error-messages="firstNameErrors"
                    v-model="Lead.firstName"
                    label="First name"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 sm3>
                  <v-text-field v-model="Lead.lastName" label="Last name"> </v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field v-model="Lead.businessName" label="Business name"> </v-text-field>
                </v-flex>
                <v-flex xs12 sm3>
                  <v-text-field v-model="Lead.phoneNumber" label="Phone number"> </v-text-field>
                </v-flex>
                <v-flex xs12 sm3>
                  <v-text-field v-model="Lead.email" label="Email address"> </v-text-field>
                </v-flex>
                <v-flex xs12 sm3>
                  <v-text-field v-model="Lead.locationCount" label="location count"> </v-text-field>
                </v-flex>
                <v-flex xs12 sm3>
                  <v-text-field v-model="Lead.refer" label="Refer from"> </v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12>
              <div>Source</div>
              <v-layout row wrap>
                <v-flex xs12 sm3>
                  <v-autocomplete
                    :items="comboBoxByID(7).ComboBoxDetails"
                    :label="$t('labels.status')"
                    item-text="selector"
                    item-value="id"
                    v-model="Lead.statusID"
                  >
                  </v-autocomplete>
                </v-flex>
                <v-flex xs12 sm3>
                  <v-autocomplete
                    :items="comboBoxByID(5).ComboBoxDetails"
                    :label="$t('labels.source')"
                    :error-messages="sourceErrors"
                    item-text="selector"
                    item-value="id"
                    v-model="Lead.sourceID"
                  >
                  </v-autocomplete>
                </v-flex>
                <v-flex xs12 sm3>
                  <v-autocomplete
                    :items="comboBoxByID(8).ComboBoxDetails"
                    :label="$t('labels.foundUs')"
                    :error-messages="foundUsErrors"
                    item-text="selector"
                    item-value="id"
                    v-model="Lead.foundUsID"
                  >
                  </v-autocomplete>
                </v-flex>
                <v-flex xs12 sm3>
                  <v-autocomplete
                    v-model="Lead.assignedToUserID"
                    :items="users"
                    :error-messages="assignedToErrors"
                    item-text="fullName"
                    item-value="userID"
                    :label="$t('labels.assignedTo')"
                  >
                  </v-autocomplete>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12>
              <v-expansion-panel class="elevation-0">
                <v-expansion-panel-content>
                  <div slot="header">
                    <span>{{ $t("labels.address") }}</span>
                  </div>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-text-field v-model="Lead.address" label="Address"> </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm4>
                      <v-text-field v-model="Lead.city" label="City"> </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm4>
                      <v-text-field v-model="Lead.state" label="State"> </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm4>
                      <v-text-field v-model="Lead.zipcode" label="Zipcode"> </v-text-field>
                    </v-flex>
                  </v-layout>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-flex>
            <v-flex xs12>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-textarea counter="counter" v-model="Lead.notes" :label="$t('labels.notes')">
                  </v-textarea>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer> </v-spacer>
        <v-btn color="blue darken-1" flat="flat" @click="close()">Close</v-btn>
        <v-btn color="blue darken-1" dark="dark" @click="save()">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import locationService from "../../Location/service.js";
import LeadService from "../service.js";
import DateTimePicker from "../../Global/components/DateTimePicker";
import userService from "../../User/service.js";
const { validationMixin } = require("vuelidate");
const { required, minLength, minValue } = require("vuelidate/lib/validators");

export default {
  props: {
    createDialog: {
      default: false
    },
    preSelectLocation: {
      default: false
    }
  },
  name: "create-Lead",
  data() {
    return {
      dialog: false,
      stores: [],
      users: [],
      Lead: {
        firstName: null,
        lastName: null,
        phoneNumber: null,
        email: null,
        businessName: null,
        notes: null,
        dueDate: new Date().toISOString(),
        createdAt: new Date().toISOString(),
        statusID: 27,
        address: null,
        city: null,
        state: null,
        zipcode: null,
        reporterUserID: null,
        assignedToUserID: null,
        assignedToUserName: null,
        emailAddress: null,
        sourceID: null,
        locationCount: null,
        foundUsID: null,
        refer: null,
        softwareID: null,
        foundUserId: null
      }
    };
  },
  mixins: [validationMixin],
  validations: {
    Lead: {
      firstName: {
        required,
        minLength: minLength(2)
      },
      sourceID: {
        required,
        minValue: minValue(1)
      },
      foundUsID: {
        required,
        minValue: minValue(1)
      },
      softwareID: {
        required,
        minValue: minValue(1)
      },
      assignedToUserID: {
        required,
        minValue: minValue(1)
      },
      reporterUserID: {
        required,
        minValue: minValue(1)
      }
    }
  },
  computed: {
    ...mapGetters("global", ["comboBox", "comboBoxByID", "currentUser"]),
    ...mapGetters("location", ["location"]),
    firstNameErrors() {
      const errors = [];
      if (!this.$v.Lead.firstName.$dirty) return errors;
      if (!this.$v.Lead.firstName.required) errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.Lead.firstName.minLength)
        errors.push(this.$t("validations.fieldMustbeatLeast4ChrLong"));
      return errors;
    },
    assignedToErrors() {
      const errors = [];
      if (!this.$v.Lead.assignedToUserID.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.Lead.assignedToUserID.minValue) errors.push("Pleaes user name");
      return errors;
    },
    reporterUserErrors() {
      const errors = [];
      if (!this.$v.Lead.reporterUserID.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.Lead.reporterUserID.minValue) errors.push("Pleaes user name");
      return errors;
    },
    sourceErrors() {
      const errors = [];
      if (!this.$v.Lead.sourceID.$dirty) return errors;
      if (!this.$v.Lead.sourceID.required) errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.Lead.sourceID.minValue) errors.push("Pleaes select source");
      return errors;
    },
    softwareErrors() {
      const errors = [];
      if (!this.$v.Lead.softwareID.$dirty) return errors;
      if (!this.$v.Lead.softwareID.required) errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.Lead.softwareID.minValue) errors.push("Pleaes select software");
      return errors;
    },
    foundUsErrors() {
      const errors = [];
      if (!this.$v.Lead.foundUsID.$dirty) return errors;
      if (!this.$v.Lead.foundUsID.required) errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.Lead.foundUsID.minValue) errors.push("Pleaes select software");
      return errors;
    }
  },
  components: {
    DateTimePicker
  },
  watch: {
    createDialog(val) {
      this.dialog = val;
      this.getAllUsers();
      this.Lead.assignedToUserID = this.currentUser.userID;
      this.Lead.reporterUserID = this.currentUser.userID;
    }
  },
  methods: {
    empty() {
      let newLead = {
        firstName: null,
        lastName: null,
        phoneNumber: null,
        email: null,
        businessName: null,
        notes: null,
        dueDate: new Date().toISOString(),
        createdAt: new Date().toISOString(),
        statusID: 27,
        address: null,
        city: null,
        state: null,
        zipcode: null,
        reporterUserID: null,
        assignedToUserID: null,
        assignedToUserName: null,
        emailAddress: null,
        sourceID: null,
        locationCount: null,
        foundUsID: null,
        refer: null,
        softwareID: null,
        foundUserId: null
      };
      this.Lead = newLead;
      this.$v.$reset;
    },
    setFollowingDate(val) {
      this.Lead.dueDate = val;
    },
    getAllUsers() {
      return userService.getAllCrmUser().then(result => {
        this.users = result.data;
      });
    },
    getActiveStore() {
      return locationService.getAll({ list: "active" }).then(result => {
        result.data.map(row => {
          this.stores.push({
            id: row.storeID,
            name: row.CSPID + " - " + row.businessName
          });
        });
      });
    },
    close() {
      this.empty();
      this.$emit("close");
    },
    save() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000
          })
          .fire({
            type: "error",
            title: this.$t("toastMessage.text.invalidFields")
          });
      } else {
        let contactStatus = false;
        if (!this.Lead.phoneNumber) {
          if (!this.Lead.email) {
            contactStatus = false;
          } else {
            contactStatus = true;
          }
        } else {
          contactStatus = true;
        }
        if (!contactStatus) {
          this.$swal("Lead", "Please enter contact phone number or email address", "warning");
        } else {
          return LeadService.create(this.Lead)
            .then(result => {
              if (result.status) {
                this.$swal
                  .mixin({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000
                  })
                  .fire({
                    type: "success",
                    title: "Lead created!"
                  });
                this.empty();
                this.$emit("createdLead");
              }
            })
            .catch(err => {
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000
                })
                .fire({
                  type: "error",
                  title: err.data.data
                });
            });
        }
      }

      // title: $('#LeadTitle1').val(),
      // LeadTypeID: $("#type option:selected").val(),
      // reporterUserID:#{userData.userID},
      // assignedToUserID:$('#assignedTo').val(),
      // description:$('#description').val(),
      // solution:$('#solution').val(),
      // storeID:#{store.data.storeID},
      // languageID:$("#language option:selected").val(),
      // sourceID:$("#source option:selected").val(),
      // phoneNumber:$('#contactNumber').val(),
      // name:$('#callerName').val(),
      // email:$('#emailAddress').val(),
      // priorityID:$("#priority option:selected").val(),
      // statusID:$("#status option:selected").val(),
      // softwareID:$("#software option:selected").val(),
      // createdAt: new Date().toISOString(),
      // dueDate: new Date().toISOString()
    }
  }
};
</script>

<style>
.v-expansion-panel__header {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
</style>
